import { useQuery } from '@tanstack/react-query';
import { getMe } from '../services/authService';
import { User } from '../services/authService'; // Ensure User type is available if needed for query data typing

export const useUserSession = () => {
  return useQuery<User, Error>({ // Explicitly typing the query data and error types
    queryKey: ['userSession'],
    queryFn: getMe,
    retry: false,
    // Consider adding refetchOnWindowFocus: false if session data isn't expected to change by external factors frequently
    // enabled: true, // This is the default, so explicitly setting it is not required.
  });
};
